import React, { useState } from 'react';
import { ConfirmationModal, Grid, GridItem, TextButton, Typography } from 'seagull';
import { Download } from 'seagull/icons';
import { useIoContext, useStoreActions } from "../../contexts";
import { handleRequest } from "../../infra/utils";
export function DownloadDeliverablesModal(_ref) {
  let {
    dismissModal,
    agreement,
    serviceAndBillCommands
  } = _ref;
  const {
    api
  } = useStoreActions();
  const {
    openNewTab
  } = useIoContext();
  const [showError, setShowError] = useState(false);

  async function download(serviceId, billCommandId, fileId) {
    setShowError(false);
    const [file,, hasError] = await handleRequest(api.billCommand.getDeliverableUrl(agreement.id, serviceId, billCommandId, fileId));

    if (hasError) {
      setShowError(true);
    } else {
      openNewTab(file);
    }
  }

  return /*#__PURE__*/React.createElement(ConfirmationModal, {
    title: "Download files",
    textAlignCenter: false,
    content: /*#__PURE__*/React.createElement(Grid, null, showError && /*#__PURE__*/React.createElement(GridItem, {
      span: 12
    }, /*#__PURE__*/React.createElement(Typography, {
      skin: "error"
    }, "Failed to download a file. please try again.")), serviceAndBillCommands.map(_ref2 => {
      let {
        service,
        billCommands
      } = _ref2;
      return /*#__PURE__*/React.createElement(GridItem, {
        span: 12,
        key: service.id
      }, serviceAndBillCommands.length > 1 && /*#__PURE__*/React.createElement(Typography, {
        variant: "h6"
      }, service.name), /*#__PURE__*/React.createElement(Grid, {
        rowGap: "small"
      }, billCommands[0].deliverables.files.map(file => /*#__PURE__*/React.createElement(React.Fragment, {
        key: file.fileId
      }, /*#__PURE__*/React.createElement(GridItem, {
        span: 9
      }, /*#__PURE__*/React.createElement(TextButton, {
        "data-testid": "invoice-download-file-name",
        onClick: () => download(service.id, billCommands[0].id, file.fileId)
      }, file.filename)), /*#__PURE__*/React.createElement(GridItem, {
        span: 3
      }, /*#__PURE__*/React.createElement(TextButton, {
        "data-testid": "invoice-download-file-btn",
        skin: "secondary",
        prefixIcon: /*#__PURE__*/React.createElement(Download, null),
        onClick: () => download(service.id, billCommands[0].id, file.fileId)
      }, "Download"))))));
    })),
    onCloseButtonClick: dismissModal,
    onPrimaryButtonClick: dismissModal,
    primaryButtonLabel: "Close"
  });
}